<script setup lang="ts" name="ErrorNotFound">
import BaseButton from '~/components/BaseButton.vue';
import BaseCardState from '~/components/BaseCardState.vue';
</script>

<template>
  <BaseCardState
    title="We Can’t Seem to Find The Page You Are Looking For"
    message="Return to the home page or explore other pages on left side panel."
    illustration="page-404"
    spacing="card-md"
  >
    <template #actions>
      <BaseButton to="/">Return to Home</BaseButton>
    </template>
  </BaseCardState>
</template>
